function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.16602 11.6063C1.16602 9.31734 1.16602 8.17334 1.68602 7.22534C2.20402 6.27634 3.15302 5.68834 5.05002 4.51034L7.05002 3.26934C9.05502 2.02434 10.058 1.40234 11.166 1.40234C12.274 1.40234 13.276 2.02434 15.282 3.26934L17.282 4.51034C19.179 5.68834 20.128 6.27634 20.647 7.22534C21.166 8.17434 21.166 9.31734 21.166 11.6053V13.1273C21.166 17.0273 21.166 18.9783 19.994 20.1903C18.822 21.4023 16.937 21.4023 13.166 21.4023H9.16602C5.39502 21.4023 3.50902 21.4023 2.33802 20.1903C1.16702 18.9783 1.16602 17.0283 1.16602 13.1273V11.6063Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.166 14.4023V17.4023",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d1b6be10bc3fd0699aa2337fb860c40f.svg";
export { ForwardRef as ReactComponent };